import React, { useEffect, useState } from "react";
import { Dropdown } from "semantic-ui-react";

const formatMemberSince = (memberSince) => {
  const joinedDate = new Date(memberSince);

  if (Number.isNaN(joinedDate.getTime())) {
    return memberSince;
  }

  const today = new Date();
  const years =
    today.getFullYear() -
    joinedDate.getFullYear() -
    (today.getMonth() < joinedDate.getMonth() ||
    (today.getMonth() === joinedDate.getMonth() &&
      today.getDate() < joinedDate.getDate())
      ? 1
      : 0);
  const joinedMonthYear = joinedDate.toLocaleDateString("en-GB", {
    month: "long",
    year: "numeric",
  });

  if (years < 1) {
    return `${joinedMonthYear} · Less than a year and counting`;
  }

  return `${joinedMonthYear} · ${years} ${
    years === 1 ? "year" : "years"
  } and counting`;
};

const AccountInfo = ({
  firstName,
  lastName,
  locale,
  handleChange,
  countries,
  selectedCountry,
  handleCountryChange,
  handleLocaleChange,
  userErrors,
  memberSince,
}) => {
  const [currentCountryName, setCurrentCountryName] = useState("");

  useEffect(() => {
    const currentCountry = countries.filter(
      (country) => country.key === selectedCountry,
    )[0];

    const countryName =
      currentCountry && currentCountry.text.length > 20
        ? currentCountry.text.slice(0, 20) + "..."
        : currentCountry?.text;

    setCurrentCountryName(countryName);
  }, [selectedCountry, countries]);

  const getErrorMessageFor = (type) => {
    return userErrors[type];
  };

  const firstNameError = getErrorMessageFor("first_name");
  const lastNameError = getErrorMessageFor("last_name");
  const countryError = getErrorMessageFor("country");

  return (
    <>
      <div className="set-row2">
        <div className="set-field">
          <label htmlFor="profileSidebarFirstName">First name</label>
          <input
            id="profileSidebarFirstName"
            type="text"
            className="set-input"
            value={firstName}
            onChange={(e) => handleChange(e, "firstName")}
          />
          {firstNameError && <div className="set-error">{firstNameError}</div>}
        </div>
        <div className="set-field">
          <label htmlFor="profileSidebarLastName">Last name</label>
          <input
            id="profileSidebarLastName"
            type="text"
            className="set-input"
            value={lastName}
            onChange={(e) => handleChange(e, "lastName")}
          />
          {lastNameError && <div className="set-error">{lastNameError}</div>}
        </div>
      </div>
      <div className="set-row2">
        <div className="set-field">
          <label htmlFor="profileSidebarCountry">Country</label>
          <Dropdown
            id="profileSidebarCountry"
            fluid
            search
            selection
            className="set-input set-dropdown"
            text={currentCountryName}
            options={countries}
            value={selectedCountry}
            placeholder="Select Country"
            onChange={handleCountryChange}
          />
          {countryError && <div className="set-error">{countryError}</div>}
        </div>
        <div className="set-field">
          <label htmlFor="profileSidebarLanguage">Course language</label>
          <Dropdown
            id="profileSidebarLanguage"
            fluid
            search
            className="set-input set-dropdown"
            selection
            options={[
              { key: "en", text: "English", value: "en" },
              { key: "es", text: "Spanish", value: "es" },
              { key: "fr", text: "French", value: "fr" },
              { key: "hi", text: "Hindi", value: "hi" },
              { key: "ar", text: "Arabic", value: "ar" },
              { key: "pt", text: "Portuguese", value: "pt" },
              { key: "fi", text: "Finnish", value: "fi" },
            ]}
            value={locale}
            placeholder="Select your course language"
            onChange={handleLocaleChange}
          />
        </div>
      </div>
      {memberSince && (
        <div className="set-field">
          <label>Member since</label>
          <div className="set-meta">{formatMemberSince(memberSince)}</div>
        </div>
      )}
    </>
  );
};

export default AccountInfo;
